/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-12-29 14:31:14
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-02-07 16:13:52
 */
import request from '@/utils/request'
import type * as vote from '@/typings/vote'
import type { IVoteStartDraftGetResponse, IVoteUpdate } from '@/typings/vote'
import type { CommonRes } from '@/typings'

// 待投票项目 - 列表
export async function getProjectVote(params: any) {
  return request('/api/v2/project/vote/search_project', {
    method: 'post',
    data: params
  })
}

// 中台运营 - 投票运营
export async function getVoteOperation(params: any) {
  return request('/api/v2/project/vote/search_operation', {
    method: 'post',
    data: params
  })
}

interface IRollBackVoteRequest {
  vote_id: number
}
// 项目 - 回滚发起投票
export async function rollBackVote(params: IRollBackVoteRequest) {
  return request('/api/v2/project/memo/vote/rollback', {
    method: 'post',
    data: params
  })
}

interface IGetVoteListParams {
  memo_id: number
  vote_type: number
}
// 获取所有的Memo/DD投票
export async function getVoteList(params: IGetVoteListParams) {
  return request('/api/v2/project/vote/list', {
    method: 'get',
    data: params
  })
}

interface ICloseProjectVoteRequest {
  vote_id: number
}
// 结束投票
export async function closeProjectVote(params: ICloseProjectVoteRequest) {
  return request('/api/v2/project/memo/vote/close', {
    method: 'POST',
    data: params
  })
}

interface IJumpProjectVoteRoundRequest {
  vote_id: number
}
// 跳过次轮投票
export async function JumpProjectVoteRound(params: IJumpProjectVoteRoundRequest) {
  return request('/api/v2/project/memo/vote/jump_round', {
    method: 'POST',
    data: params
  })
}

interface IAdminUpdateProjectVoteRequest {
  vote_update_memo: vote.voteUpdateMemo[]
}
// 管理员补充投票结果
export async function AdminUpdateProjectVote(params: IAdminUpdateProjectVoteRequest) {
  return request('/api/v2/project/vote/admin_update', {
    method: 'POST',
    data: params
  })
}

// Memo - 发起Memo投票
export async function startMemoVote(params: vote.IMemoStartVote) {
  return request('/api/v2/project/vote/start', {
    method: 'post',
    data: params
  })
}

interface IMemoVotingRequest {
  level_of_opinion?: string
  remark?: string
  vote_id?: number
  vote_result?: number
  vote_round?: number
  second_round_vote?: {
    level_of_opinion?: string
    remark?: string
    vote_result?: number
  }
}
// 项目Memo - Memo投票
export async function memoVoting(params: IMemoVotingRequest) {
  return request('/api/v2/project/vote/memo', {
    method: 'post',
    data: params
  })
}

interface IUpdateMemoVoteRequest {
  vote: IVoteUpdate
}
// 项目Memo - 编辑Memo投票
export async function updateMemoVote(params: IUpdateMemoVoteRequest) {
  return request('/api/v2/project/vote/update', {
    method: 'post',
    data: params
  })
}

// 获取发起投票草稿
export async function apiGetVoteStartDraft(params: { memo_id: number }) {
  return request<CommonRes<IVoteStartDraftGetResponse>>('/api/v2/project/vote/start_draft_get', {
    method: 'get',
    data: params
  })
}
interface IDeleteVoteStartDraftRequest {
  memo_id: number
}
// 项目Memo - 编辑Memo投票
export async function deleteVoteStartDraft(params: IDeleteVoteStartDraftRequest) {
  return request('/api/v2/project/vote/start_draft_delete', {
    method: 'post',
    data: params
  })
}

// ---------- 交易架构（PDWY-4702 需求2，根级 ADR-003）----------

interface ITradeStructureUpdateRequest {
  memo_id: number
  investment_amount_min: number // 必填>0；精确值时 max 传 0 由后端归一=下限
  investment_amount_max?: number
  investment_unit: number
  valuation_type?: number
  valuation_amount_min?: number
  valuation_amount_max?: number
  valuation_unit?: number
  share_ratio_min?: number
  share_ratio_max?: number
  remark?: string
}
// 交易架构保存（PC确认前 memo 创建人或持功能点 1001011「交易架构-编辑」，PC确认后持 1001012「交易架构-PC确认后编辑」；ADR-103）
export async function apiTradeStructureUpdate(params: ITradeStructureUpdateRequest) {
  return request('/api/v2/project/vote/trade_structure_update', {
    method: 'post',
    data: params
  })
}

interface ITradeStructureGetRequest {
  memo_id?: number
  vote_id?: number
}
// 交易架构查询（memo_id 或 vote_id 二选一；非 Memo 投票返回空）
export async function apiTradeStructureGet(params: ITradeStructureGetRequest) {
  return request('/api/v2/project/vote/trade_structure_get', {
    method: 'get',
    data: params
  })
}
